import SetOptDocumentNumberStep from './SetOptDocumentNumberStep';

export default SetOptDocumentNumberStep;
